import React, { useState } from "react";
import { MenuItem, Select, OutlinedInput, useTheme } from "@mui/material";
import { borderRadius, styled } from "@mui/system";

// Ajouter des styles personnalisés pour le composant Select
const CustomOutlinedInput = styled(OutlinedInput, {
  shouldForwardProp: (prop) => prop !== 'role',
})(({ role }) => {
  const isOnet = role === "onet";
  const isCompass = role === "compass";

  return {
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: isOnet ? '#06305C'  : isCompass ? '#c4ac66' : undefined,
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: isOnet ? '#06305C'  : isCompass ? '#c4ac66' : '#F7E900',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: isOnet ? '#06305C'  : isCompass ? '#c4ac66' : '#F7E900',
    borderRadius:7
  },
  '& .MuiOutlinedInput-input': {
    padding: '10.5px 14px',
  },
  '& legend': {
    maxWidth: '0px',
  },
  '& span': {
    display: 'none'
  }
}
});

const InstanceFilter = ({ data, onFilterChange, sx, role }) => {
  const theme = useTheme();
  const isOnet = role === "onet";
  const isCompass = role === "compass";
  const isDark = theme.palette.mode === "dark";
  const [filterInstance, setFilterInstance] = useState("all");

  console.log(role)
  // Le backend filtre déjà les environnements selon le viewRole (pas d'INT pour non-admin)
  // On affiche simplement tous les environnements reçus du backend
  const instanceNames = [
    ...new Set(
      data.map((item) => item.content.environnement)
    ),
  ];

  const handleFilterChange = (e) => {
    const instanceName = e.target.value;
    
    setFilterInstance(instanceName);
    onFilterChange(instanceName);
  };

  return (
    <Select
      key={`instance-filter-${role}`}
      value={filterInstance}
      onChange={handleFilterChange}
      input={<CustomOutlinedInput label="Toutes les instances" role={role} />}
      sx={{
        height: "40px",
        ...sx,
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            borderColor: isOnet ? '#06305C'  : isCompass ? '#c4ac66' : '#F7E900',
          },
          '&:hover fieldset': {
            borderColor: isOnet ? '#06305C'  : isCompass ? '#c4ac66' : '#F7E900',
          },
          '&.Mui-focused fieldset': {
            borderColor: isOnet ? '#06305C'  : isCompass ? '#c4ac66' : '#F7E900',
          },
        }
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            backgroundColor: theme.palette.background.paper,
            '& .MuiMenuItem-root': {
              color: theme.palette.text.primary,
              '&:hover': {
                backgroundColor: isOnet
                  ? 'rgba(6, 48, 92, 0.08)'
                  : isCompass
                    ? 'rgba(196, 172, 102, 0.08)'
                    : isDark
                      ? 'rgba(255, 255, 255, 0.08)'
                      : 'rgba(247, 233, 0, 0.08)',
              },
              '&.Mui-selected': {
                backgroundColor: isOnet
                  ? 'rgba(6, 48, 92, 0.12)'
                  : isCompass
                    ? 'rgba(196, 172, 102, 0.12)'
                    : 'rgba(247, 233, 0, 0.12)',
                '&:hover': {
                  backgroundColor: isOnet
                    ? 'rgba(6, 48, 92, 0.16)'
                    : isCompass
                      ? 'rgba(196, 172, 102, 0.16)'
                      : isDark
                        ? 'rgba(255, 255, 255, 0.12)'
                        : 'rgba(247, 233, 0, 0.16)',
                },
              },
            },
          },
        },
      }}
    >
      <MenuItem
        value="all"
        sx={{
          '&.Mui-selected': {
            backgroundColor: isOnet
              ? 'rgba(6, 48, 92, 0.12) !important'
              : isCompass
                ? 'rgba(196, 172, 102, 0.12) !important'
                : 'rgba(247, 233, 0, 0.12) !important',
          },
          '&.Mui-selected:hover': {
            backgroundColor: isOnet
              ? 'rgba(6, 48, 92, 0.16) !important'
              : isCompass
                ? 'rgba(196, 172, 102, 0.16) !important'
                : isDark
                  ? 'rgba(255, 255, 255, 0.12) !important'
                  : 'rgba(247, 233, 0, 0.16) !important',
          },
        }}
      >
        Toutes les instances
      </MenuItem>
      {instanceNames.map((instanceName) => (
        <MenuItem
          key={instanceName}
          value={instanceName}
          sx={{
            '&.Mui-selected': {
              backgroundColor: isOnet
                ? 'rgba(6, 48, 92, 0.12) !important'
                : isCompass
                  ? 'rgba(196, 172, 102, 0.12) !important'
                  : 'rgba(247, 233, 0, 0.12) !important',
            },
            '&.Mui-selected:hover': {
              backgroundColor: isOnet
                ? 'rgba(6, 48, 92, 0.16) !important'
                : isCompass
                  ? 'rgba(196, 172, 102, 0.16) !important'
                  : isDark
                    ? 'rgba(255, 255, 255, 0.12) !important'
                    : 'rgba(247, 233, 0, 0.16) !important',
            },
          }}
        >
          {instanceName}
        </MenuItem>
      ))}
    </Select>
  );
};

export default InstanceFilter;
